angular.module('mx.SolutionBuilderAgent').directive('mxExpressionValidator', [
	'$parse',
	'mx.SolutionBuilderAgent.SchemaService',
	'mx.SolutionBuilderAgent.DataQueryService',
	'mx.internationalization',
	'$timeout',
	function mxExpressionValidatorDirective($parse, mxSchema, mxDataQuery, i18n, $timeout) {
		const message = i18n.get('solutionBuilderAgent.form-validation.expression');

		return {
			require: ['ngModel', '?^mxForm'],
			restrict: 'A',
			link: function (scope, element, attrs, ctrl) {
				let exptType;
				let entityClassName = null;
				let operationId = null;
				const isCondition = attrs.isCondition === 'true';
				const ngModelCtrl = ctrl[0];
				const placeholders = attrs.expressionPlaceholders;

				const attributeName = attrs.ngModel.split('.').pop();
				const params = attrs.expressionJavascriptParams ? attrs.expressionJavascriptParams.split(',') : [];
				const isLogical = attrs.expressionLogical !== 'false' && Boolean(attrs.expressionLogical);
				const allowUnknownType = attrs.allowUnknownType !== 'false' && Boolean(attrs.allowUnknownType);

				const isJs = attrs.expressionJavascript !== 'false' && Boolean(attrs.expressionJavascript);
				if (!isJs) {
					if (attrs.expressionType) {
						exptType = $parse(attrs.expressionType);
					}

					ngModelCtrl.mxErrorMessages.expression = message;
					ngModelCtrl.$$parentForm.mxErrorMessages.expression = message;

					if (attrs.mxExpressionValidator) {
						mxSchema.getClass(attrs.mxExpressionValidator).then(function (objClass) {
							if (objClass) {
								entityClassName = attrs.mxExpressionValidator;
							} else {
								scope.$parent.$watch(attrs.mxExpressionValidator, function (className) {
									if (entityClassName !== className) {
										if (className) {
											mxSchema.getClass(className).then(function (objClass) {
												if (objClass) {
													entityClassName = className;
													validate();
												}
											});
										} else {
											entityClassName = null;
											validate();
										}
									}
								});
							}
						});
					}

					if (attrs.operationId) {
						operationId = attrs.operationId;
						scope.$parent.$watch(attrs.operationId, function (opId) {
							if (operationId !== opId) {
								operationId = opId || null;
								validate();
							}
						});
					}
				}

				const validateJs = function () {
					if (initialValue === ngModelCtrl.$viewValue) {
						return;
					}

					if (ngModelCtrl.$viewValue) {
						_validateJsScript(ngModelCtrl.$viewValue);
					} else {
						ngModelCtrl.$setValidity(attributeName, true);
					}
				};

				const validate = () => (isJs ? validateJs() : validateExpr());

				const validateExpr = function () {
					const validationAttributeName = 'expression';
					const exprValue = ngModelCtrl.$viewValue || scope.$parent?.item?.[attributeName];
					if (initialValue === exprValue) {
						return;
					}

					if ((entityClassName || operationId) && exprValue) {
						mxDataQuery.evaluateColumnExpression(entityClassName, exprValue, operationId, isCondition, placeholders).then(function (dataType) {
							ngModelCtrl.$setValidity(validationAttributeName, Boolean(dataType) || allowUnknownType);
							if (exptType) {
								exptType.assign(scope, dataType);
							}
						});
					} else {
						ngModelCtrl.$setValidity(validationAttributeName, true);
						if (exptType) {
							exptType.assign(scope, '');
						}
					}
				};

				const _validateJsScript = function (script) {
					try {
						if (isLogical) {
							const safeScript = mx.components.Utils.getSafeScript(script);

							const func = new Function(params.concat('window'), 'return ' + safeScript);
							const pseudoLogicalResult = func({});
							if (pseudoLogicalResult !== true && pseudoLogicalResult !== false) {
								setInvalid('Invalid Logical expression');
							}
						} else {
							const func = new Function(params.concat('window'), ngModelCtrl.$viewValue);
							func.apply('', params);
						}

						ngModelCtrl.$setValidity(attributeName, true);
					} catch (e) {
						setInvalid(`Javascript is invalid: ${e.message}`);
					}
				};

				let initialValue = null;

				const setInvalid = function (errorMessage) {
					ngModelCtrl.mxErrorMessages[attributeName] = errorMessage;

					// reset validity
					ngModelCtrl.$setValidity(attributeName, true);
					$timeout(() => ngModelCtrl.$setValidity(attributeName, false), 10);
				};

				element.on('focus', () => (initialValue = ngModelCtrl.$viewValue));

				element.on('blur', validate);
			},
		};
	},
]);
